<div class="flex flex-col w-full justify-end gap-3 mb-3" *ngIf="data">
  <div class="grid grid-cols-2 gap-8 justify-between">
    <div class="flex flex-col gap-2">
      <label for="internalHireRevenue" class="field-label">{{
        'AdministrationService::DailyHireRate' | abpLocalization
      }}</label>
      <div
        class="flex justify-between p-2 rounded"
        [ngStyle]="{
          background: 'linear-gradient(270deg, #D5F7D2 0%, #F7F9FA 50.18%)'
        }"
      >
        <label class="text-sm font-medium">
          {{ data.internalHireRevenue }}
        </label>
        <label *ngIf="data.internalHireRevenue"
          ><p class="text-sm font-medium text-green">
            {{ 'AdministrationService::DaysInUse' | abpLocalization }} ({{
              data.internalHireRevenue / data.dailyInternalHireRate | number : '1.0-0'
            }})
          </p></label
        >
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <div class="flex flex-col gap-2">
        <label for="revenueLostNotInUse" class="field-label">{{
          'AdministrationService::RevenueLost' | abpLocalization
        }}</label>

        <div
          class="flex justify-between p-2 rounded w-full"
          [ngStyle]="{
            background: 'linear-gradient(270deg, #FFDBDE 0%, #F7F9FA 50.18%)'
          }"
        >
          <label class="text-sm font-medium">
            {{ data.revenueLostNotInUse }}
          </label>
          <label *ngIf="data.revenueLostNotInUse"
            ><p class="text-sm font-medium text-red">
              {{ 'AdministrationService::DaysNotInUse' | abpLocalization }}({{
                data.revenueLostNotInUse / data.dailyInternalHireRate | number : '1.0-0'
              }})
            </p></label
          >
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-col gap-2">
    <label for="dailyInternalHireRate" class="field-label">{{
      'AdministrationService::DailyHireRate' | abpLocalization
    }}</label>
    <input
      id="dailyInternalHireRate"
      [value]="data.dailyInternalHireRate"
      class="form-control"
      maxlength="64"
      readOnly
    />
  </div>

  <ngb-accordion #accAddress="ngbAccordion">
    <ngb-panel>
      <ng-template ngbPanelTitle>
        <div class="flex w-100 justify-between me-2">
          <label class="text-base font-medium text-black-base">
            {{ 'AdministrationService::RepairTitle' | abpLocalization }}
          </label>
          <label>{{ data.inspectionCostTotal | number : '1.2-2' }}</label>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <app-event-table
          [data]="data.inspectionDetails"
          (viewClick)="viewClick.emit($event)"
        ></app-event-table>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
